export const checkbox = {
  colorScheme: {
    light: {
      background: '{surface.100}',
      color: '{neutral.900}',
      borderColor: '{surface.600}',
    },
    dark: {
      background: '#333643',
      color: 'white',
    },
  },
};
